"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getUrl = require("./getUrl");
Object.keys(_getUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getUrl[key];
    }
  });
});
var _fixExcessiveSlashing = require("./fixExcessiveSlashing");
Object.keys(_fixExcessiveSlashing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _fixExcessiveSlashing[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _fixExcessiveSlashing[key];
    }
  });
});
//# sourceMappingURL=index.js.map